import { gql } from "@apollo/client";

export const GET_GESTION_INICIO = gql`
query gestionInicio($idEvaluacion:Int!){
  gestionInicio(idEvaluacion:$idEvaluacion) {
    fechaInicioServicio,
    idMDemora,
    observacionMDemora,
    fechaDemora,
    idNIngreso,
    idRechazoNIngreso,
    observacionNIngreso,
    fechaNIngreso
    }
  }
`;

export const adaptGestionInicio = (gestionInicioData) => ({
  fechaInicioServicio: gestionInicioData?.gestionInicio.fechaInicioServicio,
  idMDemora: gestionInicioData?.gestionInicio.idMDemora,
  observacionMDemora: gestionInicioData?.gestionInicio.observacionMDemora,
  fechaDemora: gestionInicioData?.gestionInicio.fechaDemora,
  idNIngreso: gestionInicioData?.gestionInicio.idNIngreso,
  idRechazoNIngreso: gestionInicioData?.gestionInicio.idRechazoNIngreso,
  observacionNIngreso: gestionInicioData?.gestionInicio.observacionNIngreso,
  fechaNIngreso: gestionInicioData?.gestionInicio.fechaNIngreso
});